const state = {
  LoginShowOrNot: true, // 是否登录的判断
  urlData: '123',
  GoodLengthData: 0, // 顶部购物车的总数
  // TryBookShow: false, // 电子书有试读，纸质书没有试读
  // TryBookFont: '有关联的电子书' // 有关联的电子书/纸质书 文字的问题
};

const mutations = {
  setLoginShowOrNot(state, newValue) {
    state.LoginShowOrNot = newValue;
  },
  // 其他 mutations...
};

const actions = {
  // 其他 actions...
};

export default {
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/DataStorage.js